import { SwarovskiOptikLocaleFrontend } from "@swo/storefront";
import { SwarovskiOptikSegmentShort } from "@swo/shared";
import { useEffect } from "react";
import { ecommerceTrackingAspect } from "../../domain/google-tag-manager/ecommerce-tracking-aspect";
import { PDPSwarovskiProductFrontend, PDPSwarovskiProductVariantFrontend } from "./PDP_SingleImageCarousel/state/types";

export function useProductView(
  product: PDPSwarovskiProductFrontend,
  variant: PDPSwarovskiProductVariantFrontend,
  productCategoryKey: string,
  locale: SwarovskiOptikLocaleFrontend,
  segment: SwarovskiOptikSegmentShort,
) {
  useEffect(() => {
    ecommerceTrackingAspect.productDetailView(product.name, variant, productCategoryKey, locale, segment).push();
  }, [variant.sku]);
}
